export const sequences2027 = [
  ['are', 'rage', 'agree', 'grease'],
  ['ear', 'earl', 'ariel', 'aerial'],
  ['tea', 'rate', 'after', 'faster'],
  ['ate', 'east', 'yeast', 'steady'],
  ['eat', 'late', 'later', 'travel'],
  ['are', 'care', 'crate', 'carpet'],
  ['ear', 'tear', 'heart', 'rather'],
  ['tea', 'seat', 'stake', 'streak'],
  ['ate', 'team', 'metal', 'hamlet'],
  ['eat', 'rate', 'tread', 'hatred'],
  ['are', 'read', 'aired', 'diaper'],
  ['ear', 'rate', 'heart', 'father'],
  ['tea', 'east', 'least', 'stable'],
  ['ate', 'rate', 'terra', 'arrest'],
  ['eat', 'seat', 'asset', 'safest'],
  ['are', 'rate', 'trade', 'hatred'],
  ['ear', 'gear', 'anger', 'garden'],
  ['tea', 'late', 'delta', 'detail'],
  ['ate', 'tear', 'rated', 'thread'],
  ['eat', 'tape', 'plate', 'palate'],
  ['are', 'rare', 'terra', 'rather'],
  ['ear', 'rate', 'after', 'faster'],
  ['tea', 'tear', 'water', 'wreath'],
  ['ate', 'east', 'haste', 'hasten'],
  ['eat', 'seat', 'stale', 'lasted'],
  ['are', 'fear', 'after', 'father'],
  ['ear', 'rage', 'grade', 'agreed'],
  ['tea', 'gate', 'agent', 'eating'],
  ['ate', 'tear', 'later', 'taller'],
  ['eat', 'fate', 'feast', 'safest'],
  ['are', 'dare', 'cedar', 'cradle'],
  ['ear', 'rage', 'marge', 'german'],
  ['tea', 'late', 'metal', 'mental'],
  ['ate', 'seat', 'haste', 'chaste'],
  ['eat', 'date', 'rated', 'thread'],
  ['are', 'hear', 'rehab', 'breath'],
  ['ear', 'dear', 'dream', 'admire'],
  ['tea', 'late', 'stale', 'salute'],
  ['ate', 'tear', 'mater', 'matter'],
  ['eat', 'beat', 'table', 'battle'],
  ['are', 'bare', 'saber', 'breast'],
  ['ear', 'bare', 'beard', 'barbed'],
  ['tea', 'tale', 'dealt', 'talked'],
  ['ate', 'rate', 'trade', 'dreamt'],
  ['eat', 'neat', 'eaten', 'beaten'],
  ['are', 'year', 'weary', 'sawyer'],
  ['ear', 'earn', 'raven', 'tavern'],
  ['tea', 'late', 'steal', 'latest'],
  ['ate', 'date', 'dealt', 'detail'],
  ['eat', 'rate', 'mater', 'stream'],
  ['are', 'earl', 'learn', 'rental'],
  ['ear', 'bear', 'zebra', 'blazer'],
  ['tea', 'tear', 'later', 'taller'],
  ['ate', 'tape', 'plate', 'palate'],
  ['eat', 'tale', 'delta', 'detail'],
  ['are', 'dare', 'aired', 'admire'],
  ['ear', 'rate', 'tread', 'dreamt'],
  ['ace', 'race', 'grace', 'charge'],
  ['ate', 'heat', 'earth', 'rather'],
  ['eat', 'seat', 'tease', 'seated'],
  ['are', 'tear', 'rated', 'hatred'],
  ['ear', 'bear', 'saber', 'breast'],
  ['met', 'meet', 'meter', 'remote'],
  ['ate', 'tear', 'react', 'create'],
  ['tea', 'date', 'fated', 'defeat'],
  ['are', 'tear', 'terra', 'cartel'],
  ['ear', 'gear', 'agree', 'agreed'],
  ['ten', 'neat', 'taken', 'intake'],
  ['ate', 'east', 'taste', 'estate'],
  ['ain', 'nail', 'align', 'ailing'],
  ['are', 'rate', 'alter', 'learnt'],
  ['ear', 'dear', 'cared', 'scared'],
  ['sat', 'seat', 'asset', 'safest'],
  ['let', 'tale', 'plate', 'palate'],
  ['led', 'dale', 'laced', 'placed'],
  ['lad', 'lead', 'blade', 'bailed'],
  ['rad', 'darn', 'drain', 'daring'],
  ['dig', 'ding', 'dingo', 'indigo'],
  ['tea', 'east', 'asset', 'assert'],
  ['act', 'cart', 'craft', 'crafty'],
  ['air', 'liar', 'trail', 'tribal'],
  ['red', 'dear', 'dread', 'traded'],
  ['ate', 'beat', 'beast', 'stable'],
  ['cat', 'coat', 'actor', 'factor'],
  ['sat', 'seat', 'caste', 'aspect'],
  ['eat', 'seat', 'feast', 'faster'],
  ['lad', 'deal', 'plead', 'placed'],
  ['ole', 'love', 'solve', 'shovel'],
  ['red', 'read', 'heard', 'shared'],
  ['ace', 'care', 'cream', 'scream'],
  ['see', 'else', 'sleet', 'select'],
  ['eat', 'east', 'stare', 'arrest'],
  ['arm', 'army', 'mayor', 'armory'],
  ['top', 'spot', 'sport', 'poster'],
  ['hit', 'with', 'witch', 'switch'],
  ['tea', 'tale', 'plate', 'planet'],
  ['ten', 'rent', 'brent', 'banter'],
  ['set', 'nest', 'stone', 'stolen'],
  ['lab', 'able', 'label', 'ballet'],
  ['tie', 'tire', 'liter', 'triple'],
  ['pro', 'prom', 'primo', 'import'],
  ['who', 'show', 'whose', 'showed'],
  ['set', 'east', 'steak', 'streak'],
  ['out', 'bout', 'turbo', 'robust'],
  ['tea', 'tale', 'alert', 'taller'],
  ['pit', 'trip', 'print', 'sprint'],
  ['ten', 'tend', 'tuned', 'united'],
  ['set', 'east', 'stare', 'faster'],
  ['lad', 'deal', 'dealt', 'talked'],
  ['act', 'coat', 'coast', 'mascot'],
  ['art', 'tear', 'trace', 'cartel'],
  ['aid', 'raid', 'radio', 'hairdo'],
  ['set', 'nest', 'stern', 'unrest'],
  ['lap', 'pale', 'pearl', 'player'],
  ['red', 'dear', 'grade', 'danger'],
  ['bar', 'bear', 'break', 'banker'],
  ['ran', 'rang', 'organ', 'dragon'],
  ['nor', 'iron', 'robin', 'ribbon'],
  ['per', 'rope', 'prone', 'person'],
  ['red', 'deer', 'elder', 'leader'],
  ['the', 'thee', 'there', 'either'],
  ['eat', 'tear', 'great', 'garret'],
  ['top', 'port', 'sport', 'presto'],
  ['age', 'gear', 'large', 'larger'],
  ['sea', 'seal', 'steal', 'stable'],
  ['ray', 'year', 'ready', 'prayed'],
  ['ale', 'male', 'maple', 'sample'],
  ['mad', 'made', 'aimed', 'mailed'],
  ['pal', 'slap', 'scalp', 'pascal'],
  ['ran', 'earn', 'crane', 'dancer'],
  ['lip', 'pile', 'peril', 'triple'],
  ['our', 'hour', 'humor', 'humour'],
  ['row', 'wore', 'owner', 'wonder'],
  ['air', 'rain', 'rainy', 'brainy'],
  ['sat', 'last', 'stall', 'stella'],
  ['one', 'oven', 'coven', 'novice'],
  ['tag', 'goat', 'gator', 'bogart'],
  ['hit', 'this', 'shift', 'fetish'],
  ['sea', 'seat', 'stare', 'master'],
  ['sat', 'last', 'stale', 'slater'],
  ['fat', 'fate', 'fated', 'defeat'],
  ['ran', 'rain', 'train', 'martin'],
  ['rob', 'bore', 'broke', 'broken'],
  ['lit', 'tail', 'tidal', 'detail'],
  ['net', 'tune', 'unite', 'united'],
  ['far', 'farm', 'frame', 'framed'],
  ['bar', 'bare', 'saber', 'rabies'],
  ['met', 'meat', 'metal', 'amulet'],
  ['ole', 'lose', 'slope', 'gospel'],
  ['rid', 'raid', 'triad', 'adrift'],
  ['art', 'rate', 'water', 'waiter'],
  ['ran', 'near', 'anger', 'german'],
  ['ill', 'will', 'willy', 'wildly'],
  ['age', 'game', 'omega', 'homage'],
  ['aid', 'raid', 'triad', 'adrift'],
  ['art', 'rate', 'grate', 'gather'],
  ['ate', 'date', 'trade', 'hatred'],
  ['see', 'seen', 'tense', 'senate'],
  ['sit', 'list', 'split', 'pistol'],
  ['sad', 'sand', 'sedan', 'ascend'],
  ['art', 'cart', 'trace', 'carpet'],
  ['ace', 'race', 'reach', 'archer'],
  ['nut', 'turn', 'grunt', 'urgent'],
  ['not', 'tone', 'atone', 'donate'],
  ['let', 'tale', 'steal', 'castle'],
  ['aid', 'idea', 'aimed', 'maiden'],
  ['gee', 'gene', 'green', 'energy'],
  ['car', 'cart', 'cater', 'cartel'],
  ['rid', 'raid', 'rapid', 'diaper'],
  ['sat', 'star', 'strap', 'pastry'],
  ['ale', 'lame', 'medal', 'mailed'],
  ['set', 'east', 'least', 'latest'],
  ['let', 'tale', 'later', 'taller'],
  ['fit', 'lift', 'filet', 'itself'],
  ['bat', 'stab', 'blast', 'stable'],
  ['gee', 'gene', 'genie', 'seeing'],
  ['red', 'ride', 'weird', 'weirdo'],
  ['hot', 'shot', 'south', 'sought'],
  ['art', 'rate', 'terra', 'arrest'],
  ['bat', 'beat', 'table', 'battle'],
  ['raw', 'ward', 'drawn', 'wander'],
  ['ran', 'rang', 'groan', 'morgan'],
  ['lit', 'lift', 'filet', 'itself'],
  ['arm', 'farm', 'frame', 'farmer'],
  ['net', 'tone', 'tenor', 'orient'],
  ['son', 'nose', 'noose', 'loosen'],
  ['sir', 'risk', 'risky', 'frisky'],
  ['fed', 'deaf', 'fated', 'defeat'],
  ['pet', 'step', 'upset', 'purest'],
  ['lit', 'lift', 'filth', 'flight'],
  ['had', 'head', 'shade', 'shared'],
  ['sir', 'rise', 'siren', 'senior'],
  ['sea', 'east', 'taste', 'estate'],
  ['met', 'mate', 'mater', 'master'],
  ['red', 'reed', 'elder', 'dealer'],
  ['don', 'done', 'owned', 'wooden'],
  ['set', 'step', 'paste', 'aspect'],
  ['sea', 'seal', 'slate', 'latest'],
  ['lap', 'slap', 'lapse', 'please'],
  ['red', 'read', 'armed', 'admire'],
  ['rip', 'pair', 'prima', 'primal'],
  ['rob', 'born', 'baron', 'carbon'],
  ['air', 'raid', 'rabid', 'bridal'],
  ['owe', 'wore', 'lower', 'flower'],
  ['ace', 'case', 'space', 'escape'],
  ['raw', 'wear', 'swear', 'answer'],
  ['one', 'note', 'tenor', 'rotten'],
  ['man', 'name', 'means', 'seaman'],
  ['wet', 'west', 'waste', 'wasted'],
  ['lap', 'lamp', 'maple', 'palmer'],
  ['art', 'star', 'stare', 'arrest'],
  ['ole', 'mole', 'motel', 'omelet'],
  ['row', 'wore', 'power', 'powder'],
  ['the', 'heat', 'earth', 'rather'],
  ['led', 'dale', 'blade', 'doable'],
  ['air', 'liar', 'grail', 'gloria'],
  ['arm', 'army', 'marry', 'martyr'],
  ['rat', 'tear', 'stare', 'breast'],
  ['sir', 'risk', 'skirt', 'strike'],
  ['low', 'blow', 'bowel', 'wobble'],
  ['sea', 'case', 'cease', 'ceased'],
  ['bee', 'beer', 'weber', 'beware'],
  ['nut', 'tune', 'unite', 'minute'],
  ['sat', 'east', 'state', 'latest'],
  ['led', 'lead', 'blade', 'bailed'],
  ['pit', 'spit', 'split', 'pistol'],
  ['car', 'race', 'creak', 'hacker'],
  ['age', 'gear', 'glare', 'gravel'],
  ['due', 'rude', 'urged', 'grudge'],
  ['act', 'cart', 'crate', 'carpet'],
  ['sir', 'rise', 'arise', 'raised'],
  ['her', 'here', 'ether', 'tether'],
  ['owe', 'wore', 'worse', 'shower'],
  ['and', 'sand', 'sedan', 'sundae'],
  ['sea', 'east', 'sweat', 'wasted'],
  ['bar', 'brat', 'abort', 'barton'],
  ['row', 'wore', 'swore', 'slower'],
  ['set', 'rest', 'stern', 'resent'],
  ['top', 'post', 'sport', 'sprout'],
  ['sat', 'seat', 'stake', 'basket'],
  ['doc', 'cold', 'scold', 'closed'],
  ['ask', 'task', 'skate', 'staked'],
  ['net', 'sent', 'stern', 'resent'],
  ['age', 'gear', 'sarge', 'grease'],
  ['red', 'dare', 'heard', 'hatred'],
  ['nor', 'born', 'boner', 'broken'],
  ['cap', 'chap', 'peach', 'preach'],
  ['set', 'seat', 'stare', 'arrest'],
  ['age', 'gave', 'grave', 'gravel'],
  ['ice', 'rice', 'price', 'pierce'],
  ['sat', 'east', 'skate', 'staked'],
  ['car', 'race', 'cream', 'scream'],
  ['ain', 'main', 'mania', 'animal'],
  ['hot', 'thou', 'ought', 'bought'],
  ['may', 'army', 'marry', 'martyr'],
  ['ace', 'care', 'carve', 'carved'],
  ['ole', 'lose', 'solve', 'solved'],
  ['hat', 'heat', 'teach', 'chaste'],
  ['car', 'scar', 'crash', 'search'],
  ['rid', 'raid', 'radio', 'hairdo'],
  ['red', 'rude', 'cured', 'cursed'],
  ['sea', 'seat', 'paste', 'aspect'],
  ['yep', 'prey', 'perry', 'prayer'],
  ['pot', 'post', 'sport', 'sprout'],
  ['yes', 'easy', 'yeast', 'stayed'],
  ['gee', 'gene', 'genre', 'gender'],
  ['sea', 'sale', 'slate', 'latest'],
  ['net', 'tune', 'unite', 'united'],
  ['led', 'lend', 'laden', 'candle'],
  ['one', 'bone', 'boner', 'broken'],
  ['and', 'band', 'brand', 'brandy'],
  ['sat', 'task', 'stake', 'casket'],
  ['tip', 'spit', 'spilt', 'spoilt'],
  ['how', 'show', 'whose', 'showed'],
  ['ale', 'male', 'medal', 'blamed'],
  ['gee', 'edge', 'wedge', 'wedged'],
  ['lap', 'lamp', 'ample', 'sample'],
  ['lit', 'tail', 'trial', 'ritual'],
  ['ran', 'near', 'learn', 'nearly'],
  ['toy', 'troy', 'forty', 'frosty'],
  ['sat', 'salt', 'slate', 'castle'],
  ['led', 'deal', 'delta', 'detail'],
  ['red', 'read', 'dared', 'traded'],
  ['sea', 'seal', 'aisle', 'serial'],
  ['rid', 'dirt', 'tried', 'direct'],
  ['pot', 'spot', 'sport', 'poster'],
  ['tie', 'tire', 'tiger', 'triage'],
  ['bet', 'bite', 'tribe', 'bitter'],
  ['out', 'thou', 'ought', 'bought'],
  ['ole', 'lose', 'louse', 'blouse'],
  ['let', 'tale', 'table', 'stable'],
  ['yet', 'type', 'typed', 'deputy'],
  ['nah', 'hang', 'chang', 'change'],
  ['one', 'open', 'prone', 'person'],
  ['dig', 'ding', 'grind', 'during'],
  ['tie', 'tied', 'tried', 'credit'],
  ['nor', 'corn', 'corny', 'crayon'],
  ['hat', 'heat', 'bathe', 'breath'],
  ['ben', 'bone', 'borne', 'bronze'],
  ['sea', 'east', 'least', 'latest'],
  ['sat', 'seat', 'sweat', 'sweaty'],
  ['set', 'east', 'haste', 'hasten'],
  ['aye', 'year', 'weary', 'sawyer'],
  ['ice', 'vice', 'voice', 'novice'],
  ['lie', 'lied', 'ideal', 'failed'],
  ['ace', 'each', 'teach', 'chaste'],
  ['one', 'done', 'drone', 'yonder'],
  ['bat', 'boat', 'abort', 'barton'],
  ['aid', 'idea', 'media', 'admire'],
  ['may', 'army', 'mayor', 'armory'],
  ['lie', 'like', 'liked', 'linked'],
  ['met', 'term', 'meter', 'temper'],
  ['net', 'tend', 'tuned', 'united'],
  ['rat', 'tear', 'water', 'wreath'],
  ['sec', 'case', 'scare', 'scared'],
  ['pan', 'plan', 'plain', 'spinal'],
  ['lie', 'line', 'liner', 'berlin'],
  ['gun', 'sung', 'stung', 'strung'],
  ['rat', 'tear', 'earth', 'rather'],
  ['dry', 'yard', 'hardy', 'hardly'],
  ['red', 'dear', 'trade', 'hatred'],
  ['tie', 'tire', 'tried', 'editor'],
  ['car', 'cart', 'react', 'traced'],
  ['net', 'note', 'often', 'soften'],
  ['ain', 'gain', 'again', 'iguana'],
  ['act', 'coat', 'actor', 'factor'],
  ['cat', 'chat', 'cheat', 'chalet'],
  ['ale', 'lame', 'ample', 'palmer'],
  ['net', 'rent', 'tenor', 'throne'],
  ['ace', 'case', 'cease', 'ceased'],
  ['tie', 'time', 'timed', 'midget'],
  ['cat', 'cast', 'stack', 'casket'],
  ['tap', 'past', 'paste', 'aspect'],
  ['lad', 'dale', 'laced', 'placed'],
  ['sat', 'salt', 'stall', 'lastly'],
  ['ten', 'neat', 'meant', 'mental'],
  ['ace', 'race', 'scare', 'scream'],
  ['sir', 'rise', 'raise', 'easier'],
  ['ask', 'task', 'stack', 'casket'],
  ['sat', 'seat', 'stage', 'staged'],
  ['one', 'tone', 'monte', 'mentor'],
  ['get', 'gate', 'grate', 'gather'],
  ['sir', 'sire', 'rinse', 'sniper'],
  ['rat', 'cart', 'crate', 'create'],
  ['rid', 'ride', 'pride', 'period'],
  ['see', 'seen', 'seine', 'seeing'],
  ['dog', 'dong', 'dingo', 'indigo'],
  ['hit', 'thin', 'think', 'knight'],
  ['hip', 'chip', 'pinch', 'chopin'],
  ['rid', 'ride', 'diver', 'driven'],
  ['bow', 'blow', 'elbow', 'blower'],
  ['red', 'read', 'aired', 'diaper'],
  ['mac', 'camp', 'cramp', 'camper'],
  ['tap', 'tape', 'plate', 'planet'],
  ['war', 'draw', 'drawn', 'warned'],
  ['art', 'rate', 'extra', 'baxter'],
  ['ran', 'rang', 'grand', 'garden'],
  ['end', 'done', 'demon', 'modern'],
  ['net', 'sent', 'stone', 'honest'],
  ['rat', 'cart', 'actor', 'factor'],
  ['row', 'worn', 'rowan', 'narrow'],
  ['ran', 'earn', 'range', 'german'],
  ['ray', 'pray', 'spray', 'pastry'],
  ['cap', 'pace', 'space', 'escape'],
  ['oil', 'soil', 'spoil', 'polish'],
  ['log', 'golf', 'glove', 'govern']
];
